// Replacement function for setInterval() that make use of requestAnimationFrame() for performance
// From https://gist.github.com/joelambert/1002116#gistcomment-1953925

/**
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * @param {function} fn The callback function
 * @param {int} delay The delay in milliseconds
 */
export function requestInterval(fn, delay) {
  let start = new Date().getTime();
  const handle = {};

  function loop() {
    const current = new Date().getTime();
    const delta = current - start;

    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }

    handle.value = window.requestAnimationFrame(loop);
  }

  handle.value = window.requestAnimationFrame(loop);
  return handle;
}

/**
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame() for better performance
 * @param {int|object} handle The callback function
 */
export function clearRequestInterval(handle) {
  window.cancelAnimationFrame(handle.value);
}
